/* eslint-disable max-lines */
import Vue from 'vue'

// Import main app class and routes data.
import { WebsiteApp } from './app'

import applogger from '@applogger'

import blobProcessorHandlers from './components/website/content-lists/content-creator-content/processor.js'

import appStartup from './app-start'
import filtersInit from './app-start/filters'
import editPagesInit from './app-start/editpages'
import memberPortalInit from './app-start/member-portal'
import ecommerceInit from './app-start/ecommerce'
import contentComponentsInit from './app-start/content'

import {
  NavPlugin,
  NavbarPlugin,
  LayoutPlugin,
  ButtonPlugin,
  FormCheckboxPlugin,
  FormGroupPlugin,
  FormPlugin,
  FormInputPlugin,
  FormRadioPlugin,
  FormSelectPlugin,
  FormTextareaPlugin,
  InputGroupPlugin,
  TablePlugin,
  TabsPlugin,
  PopoverPlugin,
  TooltipPlugin,
  SpinnerPlugin,
  ModalPlugin,
  FormDatepickerPlugin,
  CardPlugin,
  FormSpinbuttonPlugin,
  AlertPlugin,
  ProgressPlugin,
  PaginationPlugin,
  SidebarPlugin,
  FormTagsPlugin
} from 'bootstrap-vue'

import ContentCreator from 'dev/content-creator'
import ImageGallery from 'dev/vuejs-fusws-image-gallery'
import SomnambulistUI from 'dev/somnambulist-ui'
import CalculoConfig from 'dev/vuejs-calculo-configurator'
import Cookiebar from 'dev/vuejs-cookie-bar'
import ProductManager from 'dev/vuejs-product-manager'
import SingleProductPagesModule from 'dev/vuejs-product-page'
import LoadingSpinner from '@aspedia/loading-spinner'

import ContentListRegistry from 'dev/content-creator/content-list-registry'

import ageGate from 'dev/vuejs-age-gate'
import Sitegate from 'dev/vuejs-sitegate'

// Import AspediaCRMAGGrid, ProductManagerList and MultiCatalogueEditor only
// in client-side builds, not in SSR - all three are admin/editor-only tools
// behind CheckAccountPermissions, and main-server.js never populates real
// auth server-side (user/init is gated on `typeof window !== 'undefined'`),
// so there's nothing for these to meaningfully render during SSR anyway.
let AspediaCRMAGGrid = null
let ProductManagerList = null
let MultiCatalogueEditor = null
if (process.env.SERVER_BUILD !== 'ssr') {
  AspediaCRMAGGrid = require('dev/aspedia-crm-aggrid').default
  ProductManagerList = require('dev/vuejs-product-manager-list').default
  MultiCatalogueEditor = require('dev/multicatalogue-editor').default
}

// Create the actual app instance.
applogger.log('Create new WebsiteApp Instance.')

const app = new WebsiteApp()

appStartup(app, Vue)
filtersInit(app, Vue)
editPagesInit(app, Vue)
contentComponentsInit(app, Vue)

app.addPlugin(NavbarPlugin, false)
app.addPlugin(NavPlugin, false)
app.addPlugin(LayoutPlugin, false)
app.addPlugin(ButtonPlugin, false)
app.addPlugin(FormCheckboxPlugin, false)
app.addPlugin(FormGroupPlugin, false)
app.addPlugin(FormPlugin, false)
app.addPlugin(FormInputPlugin, false)
app.addPlugin(FormRadioPlugin, false)
app.addPlugin(FormSelectPlugin, false)
app.addPlugin(FormTextareaPlugin, false)
app.addPlugin(InputGroupPlugin, false)
app.addPlugin(TablePlugin, false)
app.addPlugin(TabsPlugin, false)
app.addPlugin(PopoverPlugin, false)
app.addPlugin(TooltipPlugin, false)
app.addPlugin(SpinnerPlugin, false)
app.addPlugin(ModalPlugin, false)
app.addPlugin(SidebarPlugin, false)
app.addPlugin(FormDatepickerPlugin, false)
app.addPlugin(CardPlugin, false)
app.addPlugin(FormSpinbuttonPlugin, false)
app.addPlugin(AlertPlugin, false)
app.addPlugin(ProgressPlugin, false)
app.addPlugin(PaginationPlugin, false)
app.addPlugin(FormTagsPlugin, false)

const blobPreloadIDs = ['main-menu']

if (process.env.SERVER_BUILD !== 'ssr') {
  const MediaManager = require('@aspedia/media-manager')
  app.addPlugin(MediaManager.default, { lazyStore: false })

  const EditPages = require('dev/edit-pages')
  app.addPlugin(EditPages.default)

  const VueAwesomeSwiper = require('vue-awesome-swiper')
  app.addPlugin(VueAwesomeSwiper.default, false)
}
app.addRegistryCallback(function() {
  app.addPreloadItem(({ store }) => {
    Object.values(blobProcessorHandlers).forEach(func => {
      return store.dispatch('blob/registryBlobProcessorHandler', func)
    })
  })

  app.addComponent('goto', () => import(/* webpackChunkName: 'sponsors' */ './components/generic/goto.vue'))
  app.addRoutes([
    {
      path: '/_goto/:catchAll(.*)*',
      component: 'goto',
      name: 'Login to continue'
    }
  ])

  if (app.registry.getFeature('seo', true)) {
    app.enableSeo()
  }
  Vue.component('loading-spinner', LoadingSpinner)

  if (app.registry.getFeature('sponsors')) {
    app.addComponent('node-homepage-sponsors', () => import(/* webpackChunkName: 'sponsors' */ './components/website/content-lists/sponsorsCarousel/0001/node-homepage-sponsor'))
    app.addComponent('page-sponsors', () => import(/* webpackChunkName: 'sponsors' */ './components/website/content-lists/sponsorsCarousel/0001/page-sponsors'))
    app.addComponent('sponsors-detail', () => import(/* webpackChunkName: 'sponsors' */ './components/website/content-pages/sponsors/0001/sponsorsDetailView'))
  }

  // event-node
  if (app.registry.getFeature('events')) {
    app.addComponent('homepageEventsList', () => import(/* webpackChunkName: 'homepage' */ './components/website/homepage/0001/homepage-events-list'))
    app.addComponent('nodeHomepageEvent', () => import(/* webpackChunkName: 'homepage' */ './components/website/homepage/0001/node-homepage-event'))

    app.addComponent('featured-events-carousel', () => import(/* webpackChunkName: 'events' */ './components/website/content-pages/event/0001/featured-events-carousel'))
    app.addComponent('node-element-event-carousel', () => import(/* webpackChunkName: 'events' */ './components/website/content-pages//event/0001/node-element-event-carousel'))
    app.addComponent('page-content-type-event-header', () => import(/* webpackChunkName: 'events' */ './components/website/content-pages/event/0001/page-content-type-event-header'))
    app.addComponent('page-content-type-event', () => import(/* webpackChunkName: 'events' */ './components/website/content-pages/event/0001/page-content-type-event'))
    app.addComponent('page-layout-events-list', () => import(/* webpackChunkName: 'events' */ './components/website/content-lists/event/0001/page-layout-events-list'))
    app.addComponent('node-website-list-events-featured', () => import(/* webpackChunkName: 'events' */ './components/website/content-lists/event/0001/node-website-list-events-featured'))
    app.addComponent('node-website-list-event', () => import(/* webpackChunkName: 'events' */ './components/website/content-lists/event/0001/node-website-list-event'))
  }

  // news-node
  if (app.registry.getFeature('news')) {
    app.addComponent('page-content-type-news', () => import(/* webpackChunkName: 'news' */ './components/website/content-pages/news/0001/page-content-type-news'))
    app.addComponent('page-layout-news-list', () => import(/* webpackChunkName: 'news' */ './components/website/content-lists/news/0001/page-layout-news-list'))
    app.addComponent('node-website-list-news-featured', () => import(/* webpackChunkName: 'news' */ './components/website/content-lists/news/0001/node-website-list-news-featured'))
    app.addComponent('node-website-list-news', () => import(/* webpackChunkName: 'news' */ './components/website/content-lists/news/0001/node-website-list-news'))

    // news content-list
    ContentListRegistry.register('news', {
      label: 'Articles',
      options: 'articles'
    })
    app.addComponent('content-creator-content-list-news', () => import(/* webpackChunkName: 'content-lists' */ './components/website/content-lists/content-creator-content/0001/Type'))
  }

  // resources-node
  if (app.registry.getFeature('resources')) {
    app.addComponent('page-layout-resources-list', () => import(/* webpackChunkName: 'resources' */ './components/website/content-lists/resource/0001/page-layout-resources-list'))
    app.addComponent('page-content-type-resources', () => import(/* webpackChunkName: 'resources' */ './components/website/content-pages/resource/0001/page-content-type-resources'))
    app.addComponent('node-website-list-resources', () => import(/* webpackChunkName: 'resources' */ './components/website/content-lists/resource/0001/node-website-list-resources'))
  }

  if (app.registry.getFeature('faq')) {
    app.addComponent('page-layout-faqs-list', () => import(/* webpackChunkName: 'faq' */ './components/website/content-lists/faq/0001/page-layout-faqs-list'))
    app.addComponent('page-content-type-faq', () => import(/* webpackChunkName: 'faq' */ './components/website/content-pages/faq/0001/page-content-type-faq'))
    app.addRoutes([
      {
        path: '/faqs',
        component: 'page-layout-faqs-list',
        name: 'Frequently Asked Questions',
        meta: {
          requiresAuth: 'allow'
        }
      }
    ])
  }

  if (app.registry.getFeature('search')) {
    app.addRoutes([
      {
        path: '/search',
        component: 'page-website-search',
        name: 'Website Search',
        meta: { requiresAuth: 'allow' }
      }
    ])
    app.addComponent('page-website-search', () => import(/* webpackChunkName: 'search' */ './components/website/content-lists/search/0001/page-layout-website-search'))
  }

  if (app.registry.getFeature('page-ourpeople')) {
    app.addComponent('page-content-type-sp_people_group', () => import(/* webpackChunkName: 'special-pages' */ './components/website/content-pages/special-pages/people-group/0001/page-content-type-sp_people_group'))
    app.addComponent('sp-people-group-modal', () => import(/* webpackChunkName: 'special-pages' */ './components/website/content-pages/special-pages/people-group/0001/sp-people-group-modal'))
    app.addComponent('sp-people-group-placeholder', () => import(/* webpackChunkName: 'special-pages' */ './components/website/content-pages/special-pages/people-group/0001/sp-people-group-placeholder'))
  }
  if (app.registry.getFeature('page-timeline')) {
    app.addComponent('page-content-type-sp_timeline', () => import(/* webpackChunkName: 'special-pages' */ './components/website/content-pages/special-pages/timeline/0001/page-content-type-sp_timeline'))
  }
  if (app.registry.getFeature('page-pricing')) {
    app.addComponent('page-content-type-sp_pricing', () => import(/* webpackChunkName: 'special-pages' */ './components/website/content-pages/special-pages/pricing/0001/page-content-type-sp_pricing'))
  }
  if (app.registry.getFeature('page-features')) {
    app.addComponent('page-content-type-sp_feature', () => import(/* webpackChunkName: 'special-pages' */ './components/website/content-pages/special-pages/features/0001/page-content-type-sp_feature'))
    app.addComponent('sp-feature-feature', () => import(/* webpackChunkName: 'special-pages' */ './components/website/content-pages/special-pages/features/0001/sp-feature-feature'))
    app.addComponent('sp-feature-header', () => import(/* webpackChunkName: 'special-pages' */ './components/website/content-pages/special-pages/features/0001/sp-feature-header'))
    app.addComponent('sp-feature-highlights', () => import(/* webpackChunkName: 'special-pages' */ './components/website/content-pages/special-pages/features/0001/sp-feature-highlights'))
  }
  if (app.registry.getFeature('page-constructed')) {
    app.addComponent('page-content-type-sp_constructed', () => import(/* webpackChunkName: 'special-pages' */ './components/website/content-pages/special-pages/constructed/0001/page-content-type-sp_constructed'))
    const CircumspectisTokens = () => import(/*  webpackChunkName: 'circumspectis-tokens' */ './components/website/content-pages/special-pages/constructed/slice-types/constructed-page-form-tokens')
      .then(module => module.default)

    app.addPreloadItem(({callbackRegistry}) => {
      callbackRegistry.register('VueJSFormTokens', CircumspectisTokens)
    })
  }

  app.addComponent('page-content-type-page_content_group', () => import(/* webpackChunkName: 'page-content' */ './components/website/content-pages/content-group/0001/page-content-type-page_content_group'))

  // Generic Plugins
  // ImageContainer (FuSWS)
  // app.addComponent('image-container', () => import( /* webpackChunkName: 'common-components' */ 'dev/vuejs-fusws-image-container/src/ImageContainerWrapper'))

  // Swoggle (Switch Toggle)
  app.addComponent('swoggle', () => import(/* webpackChunkName: 'common-components' */ 'dev/vuejs-swoggle/src/Swoggle'))

  // Loader (Loading Animation)
  app.addComponent('loader', () => import(/* webpackChunkName: 'common-components' */ 'dev/vuejs-loader/src/Loader'))

  // Specific Nodes
  if (app.registry.getFeature('positions-vacant')) {
    app.addComponent('page-content-type-position_vacant', () => import(/* webpackChunkName: 'jobboard' */ './components/website/content-pages/positions-vacant/0001/page-content-type-position_vacant'))
  }

  if (app.registry.getFeature('positions-wanted')) {
    app.addComponent('page-content-type-position_wanted', () => import(/* webpackChunkName: 'jobboard' */ './components/website/content-pages/positions-wanted/0001/page-content-type-position_wanted'))
  }

  app.addComponent('dynamic-routes-dashboard', () => import(/* webpackChunkName: 'dynamic-routes' */ './components/website/dynamic-routes/0001/DynamicRoutesDashboard'))
  app.addRoutes([
    {
      name: 'Dynamic Routes Settings Dashboard',
      path: '/routes/settings',
      component: 'dynamic-routes-dashboard',
      meta: {
        CheckAccountPermissions: ['administer store'],
        requiresAuth: 'cache'
      }
    }
  ])

  // Forms Manager/Builder
  app.addComponent('form-builder-wrapper', () => import(/* webpackChunkName: 'form-manager' */ './components/website/form-manager/0001/FormBuilderWrapper'))
  app.addRoutes([
    {
      name: 'Forms Builder',
      path: '/form-manager/build',
      component: 'form-builder-wrapper',
      meta: {
        CheckAccountPermissions: ['administer store'],
        requiresAuth: 'cache'
      }
    },
    {
      name: 'Forms Builder - Edit',
      path: '/form-manager/build/:formid',
      component: 'form-builder-wrapper',
      meta: {
        CheckAccountPermissions: ['administer store'],
        requiresAuth: 'cache'
      }
    }
  ])

  // Age Gate
  if (app.registry.getFeature('age-gate')) {
    app.addPlugin(ageGate.install)

    app.addRoutes([
      {
        name: 'Age Gate Settings Dashboard',
        path: '/gate/settings',
        component: ageGate.dashboard
      }
    ])
  }

  // // Member Portal
  memberPortalInit(app)

  // Signup Module — consumed as the published @aspedia/vuejs-signup npm
  // package; the in-repo vuejs-dev/vuejs-signup-module submodule has been
  // removed in favour of the registry version.
  app.addComponent('vuejs-signup-module', () => import(/* webpackChunkName: 'signup-module' */ '@aspedia/vuejs-signup/src/components/Renderer'))

  // Signup Page
  if (app.registry.getFeature('signup-page')) {
    const signUpPage = () => import(/* webpackChunkName: "signup-page" */ 'dev/vuejs-signup-page/src/Signup')
    app.addRoutes([
      {
        path: '/signup',
        name: 'signup-page',
        component: signUpPage,
        meta: { requiresAuth: 'cache' }
      }
    ])
  }

  // Image Gallery
  if (app.registry.getFeature('image-gallery')) {
    const moduleSettings = app.registry.getModuleSetting('image-gallery')
    const numGalleries = Object.keys(moduleSettings).length
    if (numGalleries > 0) {
      app.addPlugin(ImageGallery)
      Object.keys(moduleSettings).map(gallery => {
        app.addRoutes([
          {
            path: gallery,
            component: ImageGallery.ImageGallery,
            name: moduleSettings[gallery].title,
            meta: {
              requiresAuth: 'cache',
              id: gallery,
              ...moduleSettings[gallery]
            }
          }
        ])
      })
    }
  }

  app.addPlugin(ProductManager)
  app.addRoutes([
    {
      path: '/product-manager',
      component: ProductManager.ProductManager,
      name: 'Manage and Reorder Wine Products',
      meta: {
        requiresAuth: 'cache',
        CheckAccountPermissions: ['administer store'],
        id: 'product-manager',
        title: 'Manage and Reorder Wine Products'
      }
    }
  ])

  // Calculo Configurator
  app.addPlugin(CalculoConfig, { lazyStore: true })

  const loadCalculoConfigStore = function(store) {
    if (!store.hasModule('calculo')) {
      return CalculoConfig.store().then(moduleStore => {
        store.registerModule('calculo', moduleStore.default, { preserveState: store.state.calculo !== undefined })
      })
    }
    return Promise.resolve(true)
  }

  app.addRoutes([
    {
      path: '/shipping/config',
      component: CalculoConfig.ViewWrapper,
      name: 'Configure Shipping',
      meta: {
        onload: ({ store }) => loadCalculoConfigStore(store),
        requiresAuth: 'cache',
        CheckAccountPermissions: ['administer store'],
        id: 'shipping',
        title: 'Configure Shipping',
        ssr: (process.env.SERVER_BUILD === 'ssr')
      }
    }
  ])

  // Password Recovery
  if (app.registry.getFeature('password-recovery')) {
    app.addComponent('member-portal-password-change', () => import(/* webpackChunkName: 'password-change' */ 'dev/vuejs-password-recovery/src/views/PasswordChange'))
    const passwordRecoveryPage = () => import(/* webpackChunkName: "password-change" */ 'dev/vuejs-password-recovery/src/PasswordRecovery')

    app.addRoutes([
      {
        path: '/password/:page/:userid?/:timestamp?/:token?',
        component: passwordRecoveryPage,
        name: 'Password Recovery',
        meta: { requiresAuth: 'cache' }
      }
    ])
  }

  // Manage Comms Subscriptions
  if (app.registry.getFeature('manage-comms', true)) {
    const ManageCommsPage = () => import(/* webpackChunkName: 'manage-comms-prefs' */ 'dev/vuejs-manage-comms/src/ManageComms')
    app.addRoutes([
      {
        path: '/msvbo-unsubscribe/:token',
        component: ManageCommsPage,
        name: 'Unsubscribe',
        meta: { requiresAuth: 'cache' }
      },
      {
        path: '/msvbo-preferences/:token',
        component: ManageCommsPage,
        name: 'Preferences',
        meta: { requiresAuth: 'cache' }
      }
    ])
  }

  // Wine Club
  if (app.registry.getFeature('somnambulist')) {
    let googleAddressesAPIKey = app.registry.getModuleSetting('ecommerce', 'googleAddressesAPIKey', '')
    if (googleAddressesAPIKey === '') {
      googleAddressesAPIKey = app.registry.getModuleSetting('somnambulist', 'googleAddressesAPIKey', '')
    }
    app.addPlugin(SomnambulistUI, {
      clubPath: '/wine-club',
      lazyStore: process.env.SERVER_BUILD !== 'ssr',
      googleAddressesAPIKey: googleAddressesAPIKey,
      ecommerce: app.registry.getFeature('ecommerce'),
      logger: applogger,
      router: () => app.router
    })
    const onload = ({store}) => SomnambulistUI.loadSomnambulistStore(
      store,
      googleAddressesAPIKey,
      app.registry.getFeature('ecommerce'),
      applogger
    )
    app.addRoutes([
      {
        path: '/wine-club',
        component: SomnambulistUI.SomnambulistUI,
        name: 'Wine Club',
        meta: {
          requiresAuth: 'cache',
          onload
        }
      },
      {
        path: '/wine-club/preselect/:groupId',
        component: SomnambulistUI.SomnambulistUI,
        name: 'Wine Club Preselect',
        meta: {
          requiresAuth: 'cache',
          onload

        }
      },
      {
        path: '/wine-club/:mode/:id',
        component: SomnambulistUI.SomnambulistUI,
        name: 'Wine Club Edit',
        meta: {
          requiresAuth: 'cache',
          onload
        }
      }
    ])

    // WineClub List
    if (app.registry.getFeature('wineclublist')) {
      const WineclubList = () => import(/* webpackChunkName: 'wineclubs' */ 'dev/vuejs-wineclub-list/src/WineclubList')
      const Wineclub = () => import(/* webpackChunkName: 'wineclubs' */ 'dev/vuejs-wineclub-list/src/Wineclub')
      app.addComponent('page-content-type-wine_club', Wineclub)
      app.addComponent('WineclubList', WineclubList)
      app.addRoutes([
        {
          path: '/wineclubs',
          component: WineclubList,
          name: 'Wine Club List',
          meta: {
            requiresAuth: 'cache',
            onload
          }
        }
      ])
    }
  }

  // Forms
  if (app.registry.getFeature('forms')) {
    app.addComponent('FormsAdminTool', () => import('dev/vuejs-forms/src/FormsAdminTool'))
    app.addComponent('FormBuilder', () => import('dev/vuejs-forms/src/components/FormBuilder'))
    app.addComponent('ConstructedPageFormsAdminWrapper', () => import('./components/website/form-manager/0001/ConstructedPageFormsAdminWrapper'))
    app.addComponent('SystemMenuFormsAdminWrapper', () => import('./components/website/form-manager/0001/SystemMenuFormsAdminWrapper'))

    app.addRoutes([
      {
        path: '/formsubmissions',
        component: 'SystemMenuFormsAdminWrapper',
        name: 'Forms Administration',
        meta: {
          CheckAccountPermissions: ['access all webform results'],
          requiresAuth: 'cache'
        }
      }
    ])
    app.addRoutes([
      {
        path: '/node/:nid/formsubmissions',
        component: 'ConstructedPageFormsAdminWrapper',
        name: 'Constructed Page Forms Administration',
        meta: {
          CheckAccountPermissions: ['access all webform results'],
          requiresAuth: 'cache'
        }
      }
    ])
  }

  // E-Commerce
  ecommerceInit.call(this, app, Vue)

  const moduleEnabled = (module) => app.registry.getFeature(module)
  const cookiebarEnabled = moduleEnabled('cookiebar')
  const noticebarEnabled = moduleEnabled('noticebar')
  const sitegateEnabled = moduleEnabled('sitegate')
  const concilioSettingsBlobRequired = (cookiebarEnabled || noticebarEnabled || sitegateEnabled)

  if (concilioSettingsBlobRequired) {
    blobPreloadIDs.push('concilio--site-settings')
  }

  if (cookiebarEnabled) {
    app.addPlugin(Cookiebar.install)

    app.addRoutes([
      {
        path: '/cookiebar/settings',
        component: Cookiebar.dashboard,
        name: 'Cookiebar',
        meta: {
          id: 'cookiebar-settings-dashboard',
          title: 'Cookiebar Module Settings Dashboard',
          CheckAccountPermissions: ['administer store'],
          requiresAuth: 'cache'
        }
      }
    ])
  }

  if (noticebarEnabled) {
    app.addPlugin(require('dev/vuejs-notice-bar').default)

    app.addRoutes([
      {
        path: '/noticebar/settings',
        component: require('dev/vuejs-notice-bar').default.dashboard,
        name: 'Notice bar settings',
        meta: {
          previewMode: true,
          requiresAuth: 'cache',
          CheckAccountPermissions: ['administer store']
        }
      }
    ])
  }

  if (sitegateEnabled) {
    app.addPlugin(Sitegate)

    app.addRoutes([
      {
        name: 'Site Gate Settings Dashboard',
        path: '/sitegate/dashboard',
        component: Sitegate.dashboard,
        meta: {
          CheckAccountPermissions: ['administer store'],
          requiresAuth: 'cache',
          sitegateDisableInitialLoad: true
        }
      }
    ])

    app.addRoutes([
      {
        name: 'Site Gate Individual Settings Dashboard',
        path: '/sitegate/:gate/',
        component: Sitegate.dashboardSingle,
        props: true,
        meta: {
          CheckAccountPermissions: ['administer store'],
          requiresAuth: 'cache',
          sitegateDisableInitialLoad: true
        }
      }
    ])

    // Only load AspediaCRMAGGrid and ProductManagerList in client-side builds, not in SSR
    if (process.env.SERVER_BUILD !== 'ssr' && AspediaCRMAGGrid && ProductManagerList) {
      app.addPlugin(AspediaCRMAGGrid.install)

      app.addPlugin(ProductManagerList.install, {
        agGridComponent: AspediaCRMAGGrid.aspediaCRMAGGrid
      })

      app.addRoutes([
        {
          name: 'Manage Products',
          path: '/manage-products',
          component: ProductManagerList.ProductManagerDisplay,
          props: true,
          meta: {
            CheckAccountPermissions: ['administer store'],
            requiresAuth: 'cache',
            sitegateDisableInitialLoad: true
          }
        }
      ])
    }

    app.addComponent('page-content-type-vc_shop_product', SingleProductPagesModule.singleShopProductPage)
    app.addComponent('page-content-type-product', SingleProductPagesModule.singleShopProductPage)
    app.addComponent('page-content-type-shop_product', SingleProductPagesModule.singleShopProductPage)
    app.addComponent('page-content-type-pos_product', SingleProductPagesModule.singlePOSProductPage)
    app.addComponent('page-content-type-pos_modifier_product', SingleProductPagesModule.singlePOSModifierProductPage)
    app.addComponent('page-content-type-pos_food_product', SingleProductPagesModule.singlePOSFoodProductPage)
    app.addComponent('page-content-type-wine_tasting', SingleProductPagesModule.singleWineTastingProductPage)
    app.addComponent('page-content-type-wine_glass', SingleProductPagesModule.singleWineGlassProductPage)
  }

  // Only load MultiCatalogueEditor in client-side builds, not in SSR - same
  // admin-only, no-server-auth reasoning as AspediaCRMAGGrid/ProductManagerList
  // above (CheckAccountPermissions gated, and SSR never has real auth), and
  // matches that same already-shipped precedent of the route being entirely
  // absent from the SSR router (see /manage-products above).
  if (process.env.SERVER_BUILD !== 'ssr' && MultiCatalogueEditor) {
    app.addPlugin(MultiCatalogueEditor.install)

    app.addRoutes([
      {
        name: 'Create Product Catalogue',
        path: '/catalogues/new',
        component: MultiCatalogueEditor.Editor,
        meta: {
          CheckAccountPermissions: ['administer store'],
          requiresAuth: 'cache',
          sitegateDisableInitialLoad: true
        }
      },
      {
        name: 'View Product Catalogues',
        path: '/catalogues/view',
        component: MultiCatalogueEditor.Dashboard,
        meta: {
          CheckAccountPermissions: ['administer store'],
          requiresAuth: 'cache',
          sitegateDisableInitialLoad: true
        }
      },
      {
        name: 'Edit Product Catalogue',
        path: '/catalogues/edit/:catalogueid',
        component: MultiCatalogueEditor.Editor,
        meta: {
          CheckAccountPermissions: ['administer store'],
          requiresAuth: 'cache',
          sitegateDisableInitialLoad: true
        },
        props: true
      }
    ])
  }

  app.addComponent('page-layout-product-catalogue', () => import(/* webpackChunkName: 'news' */ './components/website/product-lists/product-catalogue-page'))

  // Registered here (inside the registry callback) rather than after it:
  // App.run() now resets preloadStoreItems on every SSR request and relies
  // on the registry callback to fully repopulate it each time, so this
  // needs to re-run every request too, not just once at module load.
  blobPreloadIDs.push('wine-product-sort-order')
  app.addPreloadItem(({ store }) => store.dispatch('blob/loadgroup', { blobIDs: blobPreloadIDs }), 'blob-loadgroup')
})

app.addPlugin(ContentCreator)

export default app
